import { useAlert } from "components/Alerts/hooks"
import { useCallback } from "react"
import { alerts as alertKeys } from 'keys'
import { testTakerHooks } from "pages/School/CreateTestTaker"

const useAffiliationField = (schools) => {
    const { setAlerts } = useAlert()
    const closeTestTakerAlert = testTakerHooks.useAlert()

    const openNewTicketAlert = useCallback(() => {
        // למקרה שמגיעים מהוספת תלמיד
        closeTestTakerAlert(false)
        setAlerts(alertKeys.contactUs, true)
    }, [])

    const affiliation = {
        name: "school",
        placeholder: "בית ספר",
        component: "autoComplete",
        options: schools,
        getOptionLabel: (opt) => `${opt.name} ${opt.area ? `- ${opt.area}` : ""}`,
        noOptionsText:
            <div>
                אם ביה"ס שלכם לא נמצא ברשימה
                {" "}
                <span className="system-link link" onClick={openNewTicketAlert}>כתבו אלינו</span>
            </div>,
        optionsLimit: 20,
        systemUI: true,
        required: true,
        searchFields: ["name", "institution_code"],
        isOptionEqualToValue: (option, value) => option.id === value.id
    }

    return affiliation
}

export default useAffiliationField